/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductResponseDto } from '../../models/product-response-dto';

export interface GetProductBySlug$Params {
  slug: string;
}

export function getProductBySlug(http: HttpClient, rootUrl: string, params: GetProductBySlug$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductResponseDto>> {
  const rb = new RequestBuilder(rootUrl, getProductBySlug.PATH, 'get');
  if (params) {
    rb.path('slug', params.slug, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProductResponseDto>;
    })
  );
}

getProductBySlug.PATH = '/api/v1/products/slug/{slug}';
